import React from "react";

const BatteryChangeModal = ({
  isBatteryChangeModalOpen,
  setIsBatteryChangeModalOpen, // Get the setter function from props
  changeBatteryDetails,
  changeBatteryAmperesDetails,
  changeBatteryBrandsDetails,
  specificBattery,
  subCategoriesServices,
  batteryTypeId,
  setBatteryTypeId,
  batteryAmpereId,
  setBatteryAmpereId,
  batteryBrandId,
  setBatteryBrandId,
  isEdit,
  toggleSubCategories,
  createBatteryService,
}) => {
  return (
    isBatteryChangeModalOpen && (
      <div
        className="modal fade show"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={isBatteryChangeModalOpen ? "false" : "true"}
        style={{ display: "block" }}
      >
        <div className="modal-dialog orderDetails-modal" role="document">
          <div className="modal-content">
            <div className="modal-header orderDetails-modalHeader px-4">
              {isEdit ? (
                <i
                  className="fa-solid fa-circle-xmark fa-xl cursor"
                  onClick={() => setIsBatteryChangeModalOpen(false)} // Close the modal
                ></i>
              ) : (
                <i
                  onClick={toggleSubCategories}
                  className="fa-solid fa-chevron-left cursor"
                ></i>
              )}
              <div className="d-flex align-items-center mx-auto">
                <p className="modal-title orderDetails-modalTitle mx-3 fs-3 fw-semibold">
                  تغيير البطاريه
                </p>
                <i className="fa-solid fa-rotate fa-xl text-danger"></i>
              </div>
            </div>
            <div className="modal-body orderDetails-modalBody p-3">
              {/* Battery Type */}
              <div className="text-end my-2">
                <label>نوع البطاريه</label>
                <select
                  className="form-select my-2"
                  value={batteryTypeId}
                  onChange={(e) => setBatteryTypeId(e.target.value)}
                >
                  <option value="">نوع البطاريه</option>
                  {changeBatteryDetails?.types?.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Battery Ampere */}
              <div className="text-end my-2">
                <label>امبير البطاريه</label>
                <select
                  className="form-select my-2"
                  disabled={!batteryTypeId}
                  value={batteryAmpereId}
                  onChange={(e) => setBatteryAmpereId(e.target.value)}
                >
                  <option value="">امبير البطاريه</option>
                  {changeBatteryAmperesDetails?.amperes?.map((amper) => (
                    <option key={amper.id} value={amper.id}>
                      {amper.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Battery Brand */}
              <div className="text-end my-2">
                <label>ماركة البطارية</label>
                <select
                  className="form-select my-2"
                  disabled={!batteryAmpereId}
                  value={batteryBrandId}
                  onChange={(e) => setBatteryBrandId(e.target.value)}
                >
                  <option value="">ماركة البطارية</option>
                  {changeBatteryBrandsDetails?.brands?.map((brand) => (
                    <option key={brand.id} value={brand.id}>
                      {brand.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Price Breakdown */}
              <div className="d-flex justify-content-evenly my-4">
                {batteryBrandId && (
                  <p>
                    ماركة البطارية :{" "}
                    {batteryBrandId &&
                      changeBatteryBrandsDetails?.brands?.find(
                        (brand) => brand.id === parseInt(batteryBrandId)
                      )?.name}
                  </p>
                )}
                {batteryAmpereId && (
                  <p>
                    امبير البطارية :{" "}
                    {batteryAmpereId &&
                      changeBatteryAmperesDetails?.amperes?.find(
                        (amper) => amper.id === parseInt(batteryAmpereId)
                      )?.name}
                  </p>
                )}
                {batteryTypeId && (
                  <p>
                    نوع البطارية :{" "}
                    {batteryTypeId &&
                      changeBatteryDetails?.types?.find(
                        (type) => type.id === parseInt(batteryTypeId)
                      )?.name}
                  </p>
                )}
              </div>

              {/* Total Price */}
              {specificBattery && specificBattery.battery?.price > 0 ? (
                <div className="bg-secondary d-flex justify-content-between p-3 rounded-3 bg-opacity-25">
                  <p className="my-0 fw-semibold">
                    {specificBattery.battery?.price} EGP
                  </p>
                  <p className="my-0 fw-semibold">الاجمالي</p>
                </div>
              ) : subCategoriesServices[1]?.price &&
                subCategoriesServices[1]?.price > 0 ? (
                <div className="bg-secondary d-flex justify-content-between p-3 rounded-3 bg-opacity-25">
                  <p className="my-0 fw-semibold">
                    {subCategoriesServices[1]?.price} EGP
                  </p>
                  <p className="my-0 fw-semibold">الاجمالي</p>
                </div>
              ) : (
                ""
              )}
            </div>

            {/* Footer */}
            <div className="modal-footer mx-auto">
              <button
                type="button"
                className="btn btn-dark px-5 fs-5"
                onClick={createBatteryService}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default BatteryChangeModal;
